"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function Lattice(_ref) {
  var children = _ref.children,
      hideOverflow = _ref.hideOverflow,
      className = _ref.className,
      style = _ref.style;
  var latticeClasses = ["ltc"];

  if (hideOverflow) {
    latticeClasses.push("ltc--ho");
  }

  if (className) {
    latticeClasses = latticeClasses.concat(Array.isArray(className) ? className : className.split(" "));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: latticeClasses.join(" "),
    style: style
  }, children);
}

Lattice.designSystemProps = {
  children: {
    type: "node",
    description: "Grid content.",
    propType: _propTypes.default.node,
    default: null,
    required: false
  },
  hideOverflow: {
    type: "boolean",
    description: "Hides overlay content larger than the grid if true.",
    propType: _propTypes.default.bool,
    default: false,
    required: false
  },
  className: {
    type: ["string", "array"],
    description: "List of classes for this element.",
    required: false,
    propType: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
    default: ""
  },
  style: {
    type: ["object", "array"],
    description: "Inline styles for this element.",
    required: false,
    propType: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
    default: null
  }
};
var propTypes = {};
var defaultProps = {};
Object.entries(Lattice.designSystemProps).map(function (_ref2) {
  var k = _ref2[0],
      v = _ref2[1];

  if (v.propType) {
    propTypes[k] = v.propType;
  }

  if (v.default || typeof v.default !== "undefined") {
    defaultProps[k] = v.default;
  }

  return false;
});
Lattice.propTypes = Object.assign({}, propTypes);
Lattice.defaultProps = Object.assign({}, defaultProps);
Lattice.displayName = "Lattice";
var _default = Lattice;
exports.default = _default;